import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/global.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// import * as echarts from 'echarts'
import { ElMessage } from 'element-plus'
import global from './components/global.vue'

// import videojs from "video.js";
// import "video.js/dist/video-js.css";


const app =createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus,{
    locale: zhCn
})
// app.config.globalProperties.$echarts = echarts
// 全局变量
app.config.globalProperties.$GLOBAL = global
// app.config.globalProperties.$video = videojs
app.mount('#app')

// router.beforeEach((to,from,next) => {
// 	let is_Phone = false
// 	let screenWidth = document.documentElement.clientWidth
// 	if(screenWidth<1400){
// 		is_Phone= true
// 	}
// 	if(!is_Phone){
// 		if(to.fullPath=="/loading"){
// 			next("/main")
// 		}else{
// 			next()
// 		}
// 	}else{
// 		if(to.fullPath=="/loading"){
// 			next()
// 		}else{
// 			next("/loading")
// 			console.log("手机版本正在开发中...")
// 		}
// 	}
// 	console.log(to.fullPath)
// 	// console.log(from)
	
// })



// SEO路由守卫
router.beforeEach((to, from, next) => {
  // 更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 更新meta标签
  if (to.meta.metaTags) {
    // 移除旧的meta标签
    const oldMetaTags = document.querySelectorAll('meta[data-vue-router-controlled]')
    oldMetaTags.forEach(tag => tag.remove())

    // 添加新的meta标签
    to.meta.metaTags.forEach(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      tag.setAttribute('data-vue-router-controlled', '')
      document.head.appendChild(tag)
    })
  }

  next()
})

// createApp(App).use(store).use(router).mount('#app')
